class PdpSizeScarcityLabel {
  constructor(configEl) {
    this.sizes = new Set(
      (configEl.dataset.sizes || '')
        .split(',')
        .map((size) => size.trim())
        .filter(Boolean)
    );
    this.labelText = configEl.dataset.label;
    this.labelClass = 'pdp-size-scarcity-label';
    this.updateLabels = this.updateLabels.bind(this);
  }

  init() {
    this.updateLabels();

    document.querySelectorAll('[data-single-option-selector]').forEach((input) => {
      const observer = new MutationObserver(this.updateLabels);
      observer.observe(input, { attributes: true, attributeFilter: ['class'] });
    });
  }

  updateLabels() {
    document.querySelectorAll('[data-test-id="variant-size-input"]').forEach((container) => {
      const input = container.querySelector('[data-single-option-selector]');
      const stockLabel = container.querySelector('.starts-shipping-wrapper');
      if (!input || !stockLabel) return;

      const hasNotifyMe = Boolean(container.querySelector('[data-pdp-notify-me]'));
      const isAvailable =
        !hasNotifyMe && !input.classList.contains('sold-out') && !input.classList.contains('unavailable');
      const isScarceSize = this.sizes.has(input.value);
      const alreadyHasShipDate = stockLabel.textContent.trim().startsWith('Starts shipping');

      if (isAvailable && isScarceSize && !alreadyHasShipDate) {
        stockLabel.textContent = this.labelText;
        stockLabel.classList.add(this.labelClass);
      } else {
        stockLabel.classList.remove(this.labelClass);
      }
    });
  }
}

function initPdpSizeScarcityLabel() {
  const configEl = document.querySelector('[data-pdp-size-scarcity-config]');
  if (!configEl) return;
  new PdpSizeScarcityLabel(configEl).init();
}

initPdpSizeScarcityLabel();
document.addEventListener('shopify:section:load', initPdpSizeScarcityLabel);
